import { IRoute } from "../../../Interfaces/IRoute";
import { ListGroup, ListGroupDropdown, ListGroupItem } from "@sainsburys-tech/luna-list";
import { NavLink } from "react-router-dom";

export const getMenu = (
  routes: IRoute[],
  onRouteClick: (
    path: string,
    headerName: string,
    parentName: string | undefined,
    createPopupName: string | undefined,
    deletePopupName: string | undefined,
    searchPageReset: string | undefined
  ) => void,
  navLinks?: IRoute[]
): any => {
  return navLinks
    ?.filter((item) => (item.name !== "Home" && item.name !== "LDM App"))
    ?.map((data, index) => {
      /* if (data.name !== "Home")*/
      if (data.hasChild) {
        return (
          <ListGroupDropdown key={data.name} id={data.path}>
            {data.name}
            <ListGroup>
              {routes
                .filter((child) => child.parent === data.path && child.isChild)
                .map((childData, index) => {
                  return (
                    <ListGroupItem
                      className="listItem"
                      key={childData.name}
                      index={index}
                      onClick={() =>
                        onRouteClick(
                          childData.path,
                          childData.name,
                          childData.parent,
                          childData.createPopupName,
                          childData.deletePopupName,
                          childData.searchPageReset
                        )
                      }
                    >
                      {childData.name}
                    </ListGroupItem>
                  );
                })}
            </ListGroup>
          </ListGroupDropdown>
        );
      } else if (!data.parent && !data.hasLinkAccess) {
        return (
          <NavLink
            to={data.path}
            activeClassName="active-link"
            className="header-item__link remove-link"
          >
            {data.name}
          </NavLink>
        );
      }
    })
    .filter((r) => r != undefined);
};
